export default {
  FirstNameFormField__ARIA: "First name",
  FirstNameFormField__LABEL: "First name",
};
